
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.24 89.11V67.2a5.65 5.65 0 00-11.24 0v21.91M65.64 89.11V67.2a5.64 5.64 0 10-11.28 0v21.91M83.05 89.11V67.2a5.65 5.65 0 00-11.29 0v21.91M3.5 89.11h113M8.99 51.49l-3.2-7.77h108.42l-3.2 7.77M8.81 51.49h21.68V108H8.81zM111.19 108H89.51V51.49h21.68zM30.48 51.34V35.05M89.52 51.34V35.05","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"60","cy":"34.68","r":"4","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M9.09 43.6v-9h41.2a9.71 9.71 0 0119.42 0h41.2v8.9M30.64 108h58.72M93.7 22.25a64.66 64.66 0 00-67.9-.18M89.4 27.4a58.14 58.14 0 00-59.29-.17","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M93.7 22.25l-4.3 5.15a58.16 58.16 0 00-59.3-.17l-4.3-5.16a64.66 64.66 0 0167.9.18zM30.52 27.12v6.93M89.33 27.12v6.93","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    